import angular from 'angular';

angular
    .module('depositorconfirm')

    .controller('ProcessModalCtrl', [
        '$scope',
        '$uibModalInstance',
        'data',
        'selectedDepositors',
        'selectedEnvelopes',
        function($scope, $uibModalInstance, data, selectedDepositors, selectedEnvelopes) {
            var vm = this;
            vm.params = {
                envelopeIds: selectedEnvelopes,
                motif: null
            };
            vm.submit = submit;
            vm.cancel = cancel;

            $scope.includes = {
                formMessages: require('../../../common/form-messages.html')
            };

            activate();

            function activate() {
                vm.selectedEnvelopes = selectedEnvelopes.join(', ');
                vm.selectedDepositors = selectedDepositors;
                vm.data = data;
            }

            function submit() {
                $uibModalInstance.close(vm.params);
            }

            function cancel() {
                $uibModalInstance.dismiss();
            }
        }
    ]);
